import { getRequest, postRequest } from '../common/util'

export function switchProject(projectId) {
    return postRequest(`/account/save/project/${projectId}`, {})
}

export function getProfile() {
    return getRequest('/profile')
}
